import { registerPlugin } from '@capacitor/core';
export const NativePlugin = registerPlugin('NotificareAssetsPlugin', {
    web: () => import('./web').then((m) => new m.NotificareAssetsPluginWeb()),
});
//# sourceMappingURL=plugin.js.map